'use strict';

export default class Modal {
  constructor($uibModal) {
    'ngInject';

    this._$uibModal = $uibModal;
  }

  payment(text = 'Enter credit card information below.', title = 'Payment', application, size) {
    let modalInstance = this._$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./cardModal.html'),
      controller: 'ModalController',
      controllerAs: '$ctrl',
      size,
      resolve: {
        text() {
          return text;
        },
        title() {
          return title;
        },
        application() {
          return application;
        }
      }
    });

    return modalInstance.result;
  }

  confirmation(text = 'Are you sure you want to do that?', title = 'Confirm', size) {
    let modalInstance = this._$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./confirmModal.html'),
      controller: 'ModalController',
      controllerAs: '$ctrl',
      size,
      resolve: {
        text() {
          return text;
        },
        title() {
          return title;
        },
        application() {
          return {};
        }
      }
    });

    return modalInstance.result;
  }

  accept(text = 'Are you sure you want to do that?', title = 'Confirm', application, size) {
    let modalInstance = this._$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./acceptModal.html'),
      controller: 'ModalController',
      controllerAs: '$ctrl',
      size,
      resolve: {
        text() {
          return text;
        },
        title() {
          return title;
        },
        application() {
          return application;
        }
      }
    });

    return modalInstance.result;
  }

  manual(text = 'Are you sure you want to do that?', title = 'Confirm', size) {
    let modalInstance = this._$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./paymentModal.html'),
      controller: 'ModalController',
      controllerAs: '$ctrl',
      size,
      resolve: {
        text() {
          return text;
        },
        title() {
          return title;
        },
        application() {
          return {};
        }
      }
    });

    return modalInstance.result;
  }

  acceptOther(text = 'Are you sure you want to do that?', title = 'Confirm', size) {
    let modalInstance = this._$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./acceptOtherModal.html'),
      controller: 'ModalController',
      controllerAs: '$ctrl',
      size,
      resolve: {
        text() {
          return text;
        },
        title() {
          return title;
        },
        application() {
          return {};
        }
      }
    });

    return modalInstance.result;
  }

}



// WEBPACK FOOTER //
// ./client/components/modal/modal.service.js